import type { UserListItemTenantDto } from '@/features/superAdmin/features/users/types/superAdmin-users-dto';

export enum UserActivitySource {
    App = 0,
    Keycloak = 1,
}

export type UserActivityListItemDto = {
    date: Date;
    source: UserActivitySource;
    eventType: string;
    userId: string;
    userName: string;
    details?: string | null;
    assignedTenants?: UserListItemTenantDto[];
};

export type UserActivityListResponseDto = {
    items?: UserActivityListItemDto[];
    totalCount: number;
};

export type UserActivitySourceFilter = UserActivitySource | null;
